export default __webpack_public_path__ + "static/media/schedules.37af55da.svg";